"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _MeterReadingGeneric = _interopRequireDefault(require("../../Anonym/MeterReadingGeneric/MeterReadingGeneric"));
var _NoRegisterError = _interopRequireDefault(require("../../Anonym/NoRegisterError/NoRegisterError"));
var _meterReadingInfoMessageDisplayHelper = _interopRequireDefault(require("./meterReadingInfoMessageDisplayHelper"));
var MeterReadingInfoMessageDisplay = function MeterReadingInfoMessageDisplay(props) {
  var _props$errorArgs;
  var infoMessageText = props.allMetersLocked ? props.allMetersLockedText : (0, _meterReadingInfoMessageDisplayHelper.default)((_props$errorArgs = props.errorArgs) === null || _props$errorArgs === void 0 ? void 0 : _props$errorArgs.infoMessages, props.meterReadingInfoMessages) || props.noRegisterError;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12 form-wrapper form-wrapper--has-shadow ano-meter-reading"
  }, /*#__PURE__*/_react.default.createElement(_MeterReadingGeneric.default, {
    genericTitle: props.genericTitle
  }), /*#__PURE__*/_react.default.createElement(_NoRegisterError.default, (0, _extends2.default)({}, props, {
    isSmallText: true,
    noRegisterError: infoMessageText
  })));
};
var _default = exports.default = MeterReadingInfoMessageDisplay;